const GAP = 2;
const INDICATORS_VALUES = {
  indicator: {
    square: {
      l: {
        radius: 8,
        offset: [4, 4]
      },
      m: {
        radius: 8,
        offset: [4, 4]
      },
      s: {
        radius: 8,
        offset: [4, 4]
      },
      xs: {
        radius: 8,
        offset: [7, 7]
      }
    },
    circle: {
      l: {
        radius: 8,
        offset: [0, 0]
      },
      m: {
        radius: 8,
        offset: [2, 2]
      },
      s: {
        radius: 8,
        offset: [4, 4]
      },
      xs: {
        radius: 8,
        offset: [9, 5]
      }
    }
  },
  status: {
    square: {
      l: {
        radius: 5,
        offset: [1, 1]
      },
      m: {
        radius: 5,
        offset: [1, 1]
      },
      s: {
        radius: 5,
        offset: [1, 1]
      },
      xs: {
        radius: 3,
        offset: [1, 1]
      }
    },
    circle: {
      l: {
        radius: 5,
        offset: [-5, -5]
      },
      m: {
        radius: 5,
        offset: [-1, -1]
      },
      s: {
        radius: 5,
        offset: [1, 1]
      },
      xs: {
        radius: 3,
        offset: [-1, -1]
      }
    }
  }
};
export {
  GAP,
  INDICATORS_VALUES
};
//# sourceMappingURL=constants2.js.map
